import { render, staticRenderFns } from "./DropdownSortOrderBy.vue?vue&type=template&id=1928f214&"
import script from "./DropdownSortOrderBy.vue?vue&type=script&lang=js&"
export * from "./DropdownSortOrderBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1928f214')) {
      api.createRecord('1928f214', component.options)
    } else {
      api.reload('1928f214', component.options)
    }
    module.hot.accept("./DropdownSortOrderBy.vue?vue&type=template&id=1928f214&", function () {
      api.rerender('1928f214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/DropdownSortOrderBy.vue"
export default component.exports